import React from 'react';
import { Fragment } from 'react';
import $ from 'jquery'; // Import jQuery here


export interface BackdropProps {
    on: boolean
}

export class Backdrop extends React.Component<BackdropProps> {
    activeElement: any

    componentDidUpdate(prevProps: BackdropProps) {
      if (prevProps && prevProps.on != this.props.on) {
        if (this.props.on) {
          $('<div/>', {
            class: 'ajax-backdrop',
          }).appendTo('body').focus()

          setTimeout(() => {
            this.activeElement = document.activeElement
            if (this.activeElement && this.activeElement.blur) {
              this.activeElement.blur()
            }
          }, 2)
        } else {
          $('.ajax-backdrop').first().remove()
          if (this.activeElement) {
            this.activeElement.focus()
            this.activeElement = null
          }
        }
      }
    }

    componentWillUnmount() {
      if (this.props.on) {
        $('.ajax-backdrop').first().remove()
        this.activeElement = null
      }
    }

    render() {
      return <></>
    }
}
